import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form__fields-title"
}
const _hoisted_2 = { class: "form__field form__radios" }
const _hoisted_3 = ["name", "id", "value", "aria-invalid", "aria-describedby", "checked"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_6 = ["id"]

import { FormOption } from "@/types/formOption";
import { Status} from '@/validation'
import { ref } from "vue";
import { useI18n } from "vue3-i18n";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormRadios',
  props: {
    title: {},
    name: {},
    modelValue: {},
    options: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "validated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
  validateInput: validateRadios
})

// eslint-disable-next-line
const emit = __emit;

const { t } = useI18n();
const status = ref<Status>({ valid: true });

function handleChange(e: Event) {
  const groupName = (e.target as HTMLInputElement).name;
  validateRadios(groupName);

  const value = (e.target as HTMLInputElement).value;
  emit("update:modelValue", value);
}

function handleBlur(e: Event) {
  const groupName = (e.target as HTMLInputElement).name;
  validateRadios(groupName)
}

function validateRadios(groupName:string) {
  const isChecked = document.querySelector(`[name=${groupName}]:checked`) != null;

  status.value = { valid: props.required ? isChecked : true };

  emit("validated", props.name, status.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form__fields-container", { error: !status.value.valid }])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "form__radio",
          key: option.name
        }, [
          _createElementVNode("input", {
            type: "radio",
            name: _ctx.name,
            id: `${_ctx.name}-${option.name}`,
            value: option.name,
            "aria-invalid": !status.value.valid,
            "aria-describedby": `error__${_ctx.name}`,
            checked: _ctx.modelValue === option.name,
            onChange: handleChange,
            onBlur: handleBlur
          }, null, 40, _hoisted_3),
          _createElementVNode("label", {
            for: `${_ctx.name}-${option.name}`
          }, [
            _createTextVNode(_toDisplayString(option.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ]),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "form__error-message",
          id: `error__${_ctx.name}`
        }, _toDisplayString(_unref(t)('validation.select')), 9, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})